/**
 * Unpatching these events for performance. If we need to run change detection on the basis of one of these events
 * then we should explicitly do it as running change detection on all of these events is not neccessary in nearly
 * every case and causes performance issues in the plans list component given the amount of processing in the template.
 */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'keydown', 'keyup', 'keypress', 'input'];
